import React from "react";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";

import { ThemeProvider } from "themes";
import { UserProvider } from "contexts/UserContext";
import { MainRouter } from "routers/MainRouter";

const App = () => (
  <ThemeProvider>
    <UserProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <MainRouter />
      </LocalizationProvider>
    </UserProvider>
  </ThemeProvider>
);

export default App;
